import { State } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { CreateDco } from '../create/create-dco';
import { filter, takeUntil, map, withLatestFrom } from 'rxjs/operators';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { getSlotForFormID, getSnapShotPod } from '@ordersnproducts/modules/shared/reducers';
import { getTopLocationForm } from '@ordersnproducts/modules/new-repeat-order/modules/rms-top-location/selectors';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { BehaviorSubject } from 'rxjs';

export class RepeatDco extends CreateDco {
  constructor(
    protected store: Store<State>,
    public featureToggle: FeatureToggleService,
    protected didCloseWarningModal$: BehaviorSubject<boolean>,
  ) {
    super(store, featureToggle, didCloseWarningModal$);
  }

  onInit() {
    this.monitorRecipeChangesForReset();
    this.country.getCountryCode();
    this.currentCountry = this.country.getCountryCodeProperty();
    if (this.featureToggle.isFeatureEnabled(Features.EnablePODDropdownFeature)) {
      this.monitorPointOfDelivery();
      this.monitorSnapShotPod();
    }
  }
  monitorSnapShotPod() {
    this.store
      .select(getSnapShotPod)
      .pipe(
        takeUntil(this.ngDestroy),
        map((snapshot) => {
          this.oldPod = _safe(() => snapshot.shipmentLocationId);
        }),
      )
      .subscribe();
  }

  monitorPointOfDelivery() {
    this.store
      .select(getTopLocationForm)
      .pipe(
        takeUntil(this.ngDestroy),
        filter((topLocationStateForm) => !!topLocationStateForm[0] && !!topLocationStateForm[0].values),
        withLatestFrom(this.store.select(getSlotForFormID(this.formSelector.formId))),
        map(([topLocationStateForm, slot]) => {
          if (
            ((this.oldPod && this.oldPod !== topLocationStateForm[0].values.pointOfDelivery) ||
              (!this.oldPod && topLocationStateForm[0].values.pointOfDelivery === null)) &&
            slot &&
            slot.formSnapshot != null
          ) {
            this.openResetWarningModal = true;
          }
        }),
      )
      .subscribe();
  }
}
